import React from "react";
import { Wrapper } from "@/components";
import NewSock from "./index";
import type { NewSockProps } from "./index";
import styles from "./style.less";

const NewDesign: React.FC<NewSockProps> = (props) => {
  return (
    <Wrapper className={styles.newDesign}>
      <NewSock {...props} />
    </Wrapper>
  );
};

export default NewDesign;
